import React from 'react';
import { InView } from 'react-intersection-observer'; // Importing Intersection Observer

const AboutUs = () => {
  return (
    <div className='py-8'>
      <div className="py-8 px-4 sm:px-6 lg:px-8"> {/* Added padding for smaller screens */}
        <div className="container mx-auto flex flex-col lg:flex-row items-center">
          {/* Left Section - Content */}
          <InView
            triggerOnce={true}  // Trigger animation once when element comes into view
            threshold={0.5}      // Trigger when 50% of the element is visible
          >
            {({ inView, ref }) => (
              <div
                ref={ref} // Attach intersection observer
                className={`lg:w-1/2 text-left lg:text-left mb-4 lg:mb-0 ${inView ? 'animate__animated animate__fadeInLeft' : ''}`}
              >
                <h2 className="text-3xl font-bold text-gray-800 mb-4">About EDIT EZY</h2>
                <p className="text-lg text-gray-600">
                  EDIT EZY is the ultimate design platform that allows anyone to easily create custom posters, business cards, and promotional materials. No design experience required — our user-friendly drag-and-drop editor makes the process seamless and fun!
                  <br /><br />
                  Whether you are a business, school, or individual, EDIT EZY gives you the power to bring your ideas to life. Customize ready-made templates or start from scratch to create designs that are uniquely yours. With high-quality exports and instant downloads, your designs are always ready to share or print.
                  <br /><br />
                  Join thousands of satisfied users who trust EDIT EZY to create stunning designs in just minutes. Start designing today and make your brand stand out!
                </p>
              </div>
            )}
          </InView>

          {/* Right Section - Image */}
          <InView
            triggerOnce={true}  // Trigger animation once when element comes into view
            threshold={0.5}      // Trigger when 50% of the element is visible
          >
            {({ inView, ref }) => (
              <div
                ref={ref} // Attach intersection observer
                className={`lg:w-1/2 flex justify-center ${inView ? 'animate__animated animate__fadeInRight' : ''}`}
              >
                <img
                  src="https://static.vecteezy.com/system/resources/thumbnails/012/939/271/original/animated-presentation-isolated-scene-strategy-meeting-business-plan-looped-flat-2d-characters-4k-footage-with-alpha-channel-colorful-illustration-for-mobile-website-animation-video.jpg"
                  alt="About EDIT EZY"
                  className="w-full h-auto sm:h-[250px] md:h-[300px] lg:h-[350px] object-cover rounded-lg"
                />
              </div>
            )}
          </InView>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
